export const SUITE_MEMBER_PRICE_USD = 2.99;
